/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SignatureRequestSenderCustomV1Dto = {
  type: SignatureRequestSenderCustomV1Dto.type;
  /**
   * The name of the custom sender.
   */
  custom_name: string;
};
export namespace SignatureRequestSenderCustomV1Dto {
  export enum type {
    CUSTOM = 'custom',
    ORGANIZATION = 'organization',
    USER = 'user',
    WORKSPACE = 'workspace',
  }
}
